'use client';
import type { Assign } from '@ark-ui/react';
import { HoverCard } from '@ark-ui/react';
import { type HoverCardVariantProps, hoverCard } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withRootProvider, withContext } = createStyleContext(hoverCard);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withRootProvider<
  Assign<HoverCard.RootProviderProps, HoverCardVariantProps>
>(HoverCard.RootProvider);

export type RootProps = ComponentProps<typeof Root>;
export const Root = withRootProvider<
  Assign<HoverCard.RootProps, HoverCardVariantProps>
>(HoverCard.Root);

export const Arrow = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, HoverCard.ArrowProps>
>(HoverCard.Arrow, 'arrow');

export const ArrowTip = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, HoverCard.ArrowTipProps>
>(HoverCard.ArrowTip, 'arrowTip');

export const Content = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, HoverCard.ContentProps>
>(HoverCard.Content, 'content');

export const Positioner = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, HoverCard.PositionerProps>
>(HoverCard.Positioner, 'positioner');

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, HoverCard.TriggerProps>
>(HoverCard.Trigger, 'trigger');

export { HoverCardContext as Context } from '@ark-ui/react';
